import React, { useEffect, useState } from "react";
import { ClockIcon, CubeIcon, BoltIcon } from "@heroicons/react/24/outline";
import { FaExpand, FaEdit, FaDownload, FaCopy } from "react-icons/fa";
import { lowQualityToHighQuality } from "../../config/aws";
import { USER_NAME } from "../../constant";
import { listFoldersFromS3 } from "../../config/aws";

const History = ({
  All_History,
  setSelectedGroup,
  handleDownload,
  setEditUploadedImages,
  setActiveTab,
  setModalImage,
  editPageNumber,
  setEditPageNumber,
  containerRef,
  setAllEditHistory
}) => {

  const [copiedPrompt, setCopiedPrompt] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);


  useEffect(() => {
    const fetchTotalPages = async () => {
      const folders = await listFoldersFromS3(`USERS/${USER_NAME}/all_editPage/`);
      setTotalPages(Math.ceil(folders.length / 10));
    };

    fetchTotalPages();
  }, []);



  useEffect(() => {
    // Set a timeout to change loading state after 10 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 10000); // 10 seconds in milliseconds
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (All_History.length > 0) {
      setSelectedGroup(All_History[0].images);
      setEditUploadedImages(All_History[0].images);
    }
  }, [All_History]);

  const copyPromptToClipboard = (prompt, index) => {
    navigator.clipboard.writeText(prompt)
      .then(() => {
        setCopiedPrompt(index);
        setTimeout(() => setCopiedPrompt(null), 2000);
      })
      .catch(err => {
        console.error('Failed to copy prompt: ', err);
      });
  };

  const selectFromHistory = async (entry) => {
    try {
      // console.log("in Edit History  selectFromHistory fetching all high quality images");
      // Create an array of promises
      const imagePromises = entry.images.map(async (image) => ({
        src: await lowQualityToHighQuality(image.src),
        alt: image.alt
      }));

      // Wait for all promises to resolve
      const resolvedImages = await Promise.all(imagePromises);

      // Now we have the actual data, not promises
      setSelectedGroup(resolvedImages);
      setEditUploadedImages(resolvedImages);

      // Scroll container to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error("Error processing images:", error);
    }
  }

  return (
    <footer className="bg-gradient-to-r from-gray-50 to-white p-6 border-t border-gray-200 shadow-inner">
      <div className="max-w-7xl mx-auto">
        {All_History.length > 0 && (
          <h2 className="text-3xl font-bold text-gray-800 mb-8">History</h2>
        )}
        <div className="space-y-8">
          {All_History.map((entry, index) => (
            <div key={index} className="bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300" onClick={() => selectFromHistory(entry)}>
              <div className="flex flex-wrap items-center gap-3 mb-4">
                <div className="bg-white border border-gray-300 px-2 py-1 rounded-lg text-xs font-medium font-['Plus_Jakarta_Sans']">
                  <span className="text-gray-500">Product:</span> <span className="text-black">{entry.productName || "none"}</span>
                </div>
                <div className="bg-white border border-gray-300 px-2 py-1 rounded-lg text-xs font-medium font-['Plus_Jakarta_Sans']">
                  <span className="text-gray-500">Uploaded Image:</span> <span className="text-black">{entry.uploadedProductImage === true ? "true" : entry.uploadedProductImage === false ? "false" : "none"}</span>
                </div>

                <div className="bg-white border border-gray-300 px-2 py-1 rounded-lg text-xs font-medium font-['Plus_Jakarta_Sans']">
                  <span className="text-black">{entry.time || "none"}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="bg-white border border-gray-300 px-2 py-1 rounded-lg text-xs font-medium truncate relative group font-['Plus_Jakarta_Sans']">
                    <span className="truncate block pr-8 text-black">{entry.prompt || "none"}</span>
                    <button
                      className="absolute right-1 top-1/2 transform -translate-y-1/2 bg-gray-200 hover:bg-gray-300 p-1 rounded transition-all duration-300"
                      onClick={(e) => {
                        e.stopPropagation();
                        copyPromptToClipboard(entry.prompt, index);
                      }}
                      aria-label="Copy prompt"
                    >
                      <FaCopy className="text-gray-500 text-xs group-hover:text-gray-700" />
                      <span className={`absolute -top-8 right-0 bg-gray-800 text-white text-xs py-1 px-2 rounded opacity-0 transition-opacity duration-300 whitespace-nowrap ${copiedPrompt === index ? 'opacity-100' : ''}`}>
                        {copiedPrompt === index ? 'Copied!' : 'Copy prompt'}
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {entry.images.map((image, imgIndex) => (
                  <div key={imgIndex} className="group relative aspect-square">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover rounded-xl shadow-md transition-all duration-300 group-hover:scale-105 group-hover:shadow-lg"
                      style={{ aspectRatio: '1/1' }}
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-xl"></div>
                    <div className="absolute top-2 right-2 flex gap-1.5 z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {/* <button
                        className="bg-white/80 backdrop-blur-sm p-1.5 rounded-full shadow-md hover:bg-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDownload(image);
                        }}
                      >
                        <FaDownload className="text-gray-600 text-sm" />
                      </button> */}
                      <button
                        className="bg-white/80 backdrop-blur-sm p-1.5 rounded-full shadow-md hover:bg-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                        onClick={async (e) => {
                          e.stopPropagation();
                          // console.log("in Edit History  click on send to canvas  fetching high quality images ");
                          const highQualityImage = await lowQualityToHighQuality(image.src);
                          setEditUploadedImages([{ src: highQualityImage, alt: "High Quality Image" }]);
                          setActiveTab('edit');
                          setAllEditHistory([{ images: [{ src: highQualityImage, alt: "Image from Create History" }] }, ...All_History]);
                          // Scroll container to top
                          if (containerRef && containerRef.current) {
                            containerRef.current.scrollTop = 0;
                          }
                        }}
                      >
                        <img
                          src="https://img.icons8.com/?size=100&id=ky9dlsSpTXp0&format=png&color=1A1A1A"
                          alt="Edit"
                          className="w-4 h-4"
                        />
                      </button>
                      <button
                        className="bg-white/80 backdrop-blur-sm p-1.5 rounded-full shadow-md hover:bg-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                        onClick={async (e) => {
                          e.stopPropagation();
                          setModalImage({ src: await lowQualityToHighQuality(image.src), alt: "Image expanded" });
                        }}
                      >
                        <FaExpand className="text-gray-600 text-xs" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-center items-center gap-4 mt-8">
        <div className="flex items-center gap-2">
          <button
            onClick={() => {
              if (isLoading || editPageNumber === 0) return;
              setIsLoading(true);
              setTimeout(() => {
                setEditPageNumber(editPageNumber - 1);
                setIsLoading(false);
              }, 1000);
            }}
            disabled={isLoading || editPageNumber === 0}
            className={`px-3 py-1 rounded-md transition-all duration-300 ${editPageNumber === 0
              ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
          >
            Previous
          </button>

          {Math.floor(editPageNumber / 10) > 0 && (
            <button
              onClick={() => {
                if (isLoading) return;
                setIsLoading(true);
                setTimeout(() => {
                  const prevPageSet = Math.max((Math.floor(editPageNumber / 10) - 1) * 10, 0);
                  setEditPageNumber(prevPageSet);
                  setIsLoading(false);
                }, 1000);
              }}
              className="px-2 text-gray-500 hover:text-purple-600 transition-all duration-300"
              disabled={isLoading}
            >
              ...
            </button>
          )}

          {Array.from({ length: Math.min(10, totalPages) }, (_, i) => {
            // Calculate the starting page based on current page
            const startPage = Math.floor(editPageNumber / 10) * 10;
            return startPage + i;
          }).filter(pageNum => pageNum < totalPages).map((pageNum) => (
            <button
              key={pageNum}
              onClick={() => {
                if (isLoading) return;
                setIsLoading(true);
                setTimeout(() => {
                  setEditPageNumber(pageNum);
                  setIsLoading(false);
                }, 1000);
              }}
              className={`px-3 py-1 rounded-md transition-all duration-300 ${editPageNumber === pageNum
                ? 'bg-purple-600 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              disabled={isLoading}
            >
              {pageNum + 1}
            </button>
          ))}

          {totalPages > 10 && Math.floor(editPageNumber / 10) < Math.floor((totalPages - 1) / 10) && (
            <button
              onClick={() => {
                if (isLoading) return;
                setIsLoading(true);
                setTimeout(() => {
                  const nextPageSet = Math.min((Math.floor(editPageNumber / 10) + 1) * 10, totalPages - 1);
                  setEditPageNumber(nextPageSet);
                  setIsLoading(false);
                }, 1000);
              }}
              className="px-2 text-gray-500 hover:text-purple-600 transition-all duration-300"
              disabled={isLoading}
            >
              ...
            </button>
          )}

          <button
            onClick={() => {
              if (isLoading || editPageNumber === totalPages - 1) return;
              setIsLoading(true);
              setTimeout(() => {
                setEditPageNumber(editPageNumber + 1);
                setIsLoading(false);
              }, 1000);
            }}
            disabled={isLoading || editPageNumber === totalPages - 1}
            className={`px-3 py-1 rounded-md transition-all duration-300 ${editPageNumber === totalPages - 1
              ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
          >
            Next
          </button>
        </div>
      </div>
    </footer>
  );
};

export default History;
